<div>
  <legend>{{ 'tkey;dialplanmanagement.admin.group.didranges.navlink' | translate }}</legend>

  <ziro-custom-select fieldId="route_partition"></ziro-custom-select>
  <div class="row">
    <div class="col-6 d-flex flex-column">
      <label
        [ngClass]="{
          'ziro-forms-error': extensionRangesDisplayFormValidationState === validationStates.INVALID,
          'ziro-forms-warning': extensionRangesDisplayFormValidationState === validationStates.WARNING,
        }"
        data-automation="extension-ranges-label"
        class="ziro-forms-label col-form-label"
      >
        <span>
          {{ 'tkey;dialplanmanagement.admin.group.didranges' | translate }}
        </span>
      </label>
      <div class="d-flex flex-column">
        @if (displayRangeForm) {
          <ziro-extension-ranges-display-form
            data-automation="extension-ranges-display-form"
            [entity]="displayRangeFormEntity"
            [groupId]="groupId()"
            [clusterId]="clusterId()"
            [dialPlanGroups]="dialPlanGroups()"
            [siteSummary]="siteSummary()"
            [optionalValidators]="displayRangeFormOptionalValidators"
            [isRequired]="false"
            (ziroFormsUpdate$)="onRangeFormUpdate($event)"
          ></ziro-extension-ranges-display-form>
        }
      </div>
    </div>
    <div class="col-6 d-flex flex-column justify-content-between">
      <ziro-textarea fieldId="bulkRanges"></ziro-textarea>
      <ziro-button
        [dataAutomation]="'did-ranges-bulk-ranges-button'"
        [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
        [label]="'tkey;dialplanmanagement.admin.group.generate.button'"
        (clicked)="generateBulkRangesClicked()"
      ></ziro-button>
    </div>
  </div>
</div>
